'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Button from '../Button/index.js';
import IconLoading from '../icons/IconLoading.js';
import closeIcon from './deleteIcon.js';
import s from './Dialog.module.scss.js';

var defaultOnBack = function () {
    console.warn("no \"onBack\" event handler");
};
var Dialog = function (props) {
    var isOpen = props.isOpen, _a = props.onBack, onBack = _a === void 0 ? defaultOnBack : _a, title = props.title, zIndex = props.zIndex, _b = props.backdrop, backdrop = _b === void 0 ? false : _b, _c = props.backdropClassName, backdropClassName = _c === void 0 ? '' : _c, onClickOutside = props.onClickOutside, onClickAction = props.onClickAction, onClickSecondaryButton = props.onClickSecondaryButton, _d = props.type, type = _d === void 0 ? 'default' : _d, _e = props.secondaryButtonText, secondaryButtonText = _e === void 0 ? 'Cancel' : _e, _f = props.actionText, actionText = _f === void 0 ? 'Save' : _f, _g = props.deleteText, deleteText = _g === void 0 ? 'Delete' : _g, _h = props.size, size = _h === void 0 ? 'default' : _h, _j = props.zoomIn, zoomIn = _j === void 0 ? false : _j, _k = props.primaryButtonType, primaryButtonType = _k === void 0 ? 'primary' : _k, _l = props.secondaryButtonType, secondaryButtonType = _l === void 0 ? 'default' : _l, fullScreenOnMobile = props.fullScreenOnMobile, isPrimaryButtonDisabled = props.isPrimaryButtonDisabled, _m = props.isSecondaryButtonDisabled, isSecondaryButtonDisabled = _m === void 0 ? true : _m, isShowSecondaryButton = props.isShowSecondaryButton, _o = props.isLoading, isLoading = _o === void 0 ? false : _o, _p = props.isNoHeader, isNoHeader = _p === void 0 ? false : _p, isNoFooter = props.isNoFooter, _q = props.dialogClass, dialogClass = _q === void 0 ? '' : _q, modalContainerStyle = props.modalContainerStyle, _r = props.sizeButton, sizeButton = _r === void 0 ? 'md' : _r, _s = props.gridButton, gridButton = _s === void 0 ? '1fr 1fr' : _s, _t = props.bodyStyle, bodyStyle = _t === void 0 ? {} : _t, _u = props.className, className = _u === void 0 ? '' : _u;
    var containerRef = useRef(null);
    useEffect(function () {
        var handleClickOutside = function (e) {
            var _a;
            var isClickOutside = !((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target));
            if (isClickOutside && onClickOutside) {
                onClickOutside();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(function () {
        if (isOpen && backdrop) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        if (!isOpen) {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        }
        return function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
    }, [isOpen, backdrop]);
    /**
     * In Server side rendering case, document will be undefined
     */
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    if (!bodyNode) {
        return null;
    }
    var classOpen = isOpen ? s.isOpen : '';
    var modalStyle = {};
    if (zIndex) {
        modalStyle.zIndex = zIndex;
    }
    if (modalContainerStyle) {
        modalStyle = __assign(__assign({}, modalStyle), modalContainerStyle);
    }
    // Container classes
    var fullScreenClass = fullScreenOnMobile ? s.fullScreen : '';
    var sizeClass = s["size-".concat(size)];
    var typeClass = s["container-".concat(type)];
    var zoomClass = zoomIn ? s.zoomIn : '';
    /* Render */
    return ReactDOM.createPortal(React__default.createElement("div", null,
        backdrop && React__default.createElement("div", { className: "".concat(s.backdrop, " ").concat(classOpen, " ").concat(backdropClassName) }),
        React__default.createElement("div", { className: "box-dialog ".concat(s.container, " ").concat(typeClass, " ").concat(classOpen, " ").concat(sizeClass, " ").concat(zoomClass, " ").concat(fullScreenClass, " ").concat(dialogClass, " ").concat(className), style: modalStyle, ref: containerRef },
            isNoHeader ? (React__default.createElement("span", { onClick: onBack, className: "".concat(s.icon, " ").concat(s.right, " ").concat(s.closeIcon) },
                React__default.createElement(closeIcon, null))) : (React__default.createElement("div", { className: s.header },
                React__default.createElement("div", { className: 'text-h2' }, title),
                React__default.createElement("span", { onClick: onBack, className: "".concat(s.icon, " ").concat(s.right) },
                    React__default.createElement(closeIcon, null)))),
            React__default.createElement("div", { className: s.body, style: bodyStyle }, props.children),
            React__default.createElement("div", { className: s.footer, style: { gridTemplateColumns: gridButton, display: isNoFooter ? 'none' : 'flex' } },
                isShowSecondaryButton && (React__default.createElement(Button, { type: secondaryButtonType, onClick: onClickSecondaryButton || onBack, disabled: isSecondaryButtonDisabled, size: sizeButton }, secondaryButtonText)),
                type === 'delete' ? (React__default.createElement(Button, { type: 'danger', onClick: onClickAction, disabled: isPrimaryButtonDisabled, size: sizeButton }, deleteText)) : (React__default.createElement(Button, { type: primaryButtonType, onClick: onClickAction, disabled: isPrimaryButtonDisabled || isLoading, size: sizeButton }, isLoading ? React__default.createElement(IconLoading, { width: 32, height: 32 }) : actionText))))), bodyNode);
};

export { Dialog as default };
//# sourceMappingURL=index.js.map
